import axios from 'axios'
import { API_PATH } from '../../constant/urlConstant'
import { handleAPIError } from '../common/errorHandler'
import { baseUrl } from '../PostAPI'
// import { USER_ROLE } from "../../constant/actionTypes/role";

export const fetchVillageList = async (payload) => {
  let url
  if (!payload) {
    url = `${baseUrl}${API_PATH.VILLAGE.FETCH}`
  } else {
    url = `${baseUrl}${API_PATH.VILLAGE.FETCH_BY_SUB_DISTRICT}/${payload}`
  }
  if (payload && typeof payload === 'number') {
    try {
      const result = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
          // Authorization: `Bearer ${token}`,
        }
      })
      if (result.data.error || result.status !== 200) {
        return handleAPIError(result.data.detail)
      }
      return result.data
    } catch (error) {
      console.error(error)
      return handleAPIError(error)
    }
  } else {
    return handleAPIError('error')
  }
}

export const fetchVillageListBySalesPerson = async () => {
  const url = `${baseUrl}${API_PATH.VILLAGE.FETCH_BY_SALES_PERSON}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result.data.error || result.status !== 200) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error)
  }
}

export const fetchVillageRecord = async (payload) => {
  const url = `${baseUrl}${API_PATH.VILLAGE.FETCH}/${payload}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result?.data?.error || result.status !== 200) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error)
  }
}

export const createVillageRecord = async (payload) => {
  const url = `${baseUrl}${API_PATH.VILLAGE.ADD}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    })
    if (result?.data?.error || result.status !== 201) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    return handleAPIError(error.response.data.detail)
  }
}

export const updateVillageRecord = async (payload, id) => {
  const url = `${baseUrl}${API_PATH.VILLAGE.EDIT}/${id}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    if (result?.data?.error || result.status !== 200) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    return handleAPIError(error.response.data.detail)
  }
}

export const deleteVillage = async (villageId) => {
  const url = `${baseUrl}${API_PATH.VILLAGE.DELETE}/${villageId}`
  const token = localStorage.getItem('token')
  try {
    const result = await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result?.data?.error || result.status !== 204) {
      return handleAPIError(result.data.detail)
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error.response.data.detail)
  }
}

export const getVillageCount = async (role, payload) => {
  let url = ''
  // if(USER_ROLE.ADMIN === role){
  url = `${baseUrl}${API_PATH.VILLAGE.COUNT}?tenantId.equals=${payload}`
  // }else{
  //   url = `${baseUrl}${API_PATH.VILLAGE.COUNT}?userId.equals=${payload}`;
  // }

  const token = localStorage.getItem('token')
  try {
    const result = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (result.status !== 200) {
      return handleAPIError(result?.data?.detail ?? '')
    }
    return result.data
  } catch (error) {
    console.error(error)
    return handleAPIError(error.response.data.detail)
  }
}
